import React, { useRef } from "react";
import { useButton, useMenuTrigger } from "react-aria";
import { Item, Section, useMenuTriggerState } from "react-stately";
import { Popover } from "../Popover";
import MenuList from "./MenuList";
import * as S from "./styled";
import { MenuProps } from "./types";

const Menu = <T extends object>(props: MenuProps<T>) => {
    const state = useMenuTriggerState(props);
    const popoverRef = useRef(null);
    const triggerRef = useRef(null);
    const { menuTriggerProps, menuProps } = useMenuTrigger<T>(props, state, triggerRef);
    const { buttonProps } = useButton(menuTriggerProps, triggerRef);

    return (
        <div>
            {typeof props.label === "function" ? (
                props.label({ state, props: buttonProps, ref: triggerRef })
            ) : (
                <S.TriggerWrapper {...buttonProps} ref={triggerRef}>
                    {props.label}
                </S.TriggerWrapper>
            )}

            {state.isOpen && (
                <Popover
                    offset={8}
                    placement="bottom end"
                    popoverRef={popoverRef}
                    state={state}
                    triggerRef={triggerRef}
                >
                    <MenuList {...props} {...menuProps} />
                </Popover>
            )}
        </div>
    );
};

Menu.Item = Item;
Menu.Section = Section;

export default Menu;
